import { aiModelAssignmentsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const AI_MODEL_ASSIGNMENTS_ACTION_TYPE = createNamedActions('aiModelAssignments', {
  GET_AI_MODEL_ASSIGNMENTS: 'GET_AI_MODEL_ASSIGNMENTS',
});

export const getAiModelAssignmentsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await aiModelAssignmentsApi.getAiModelAssignments(params);

  return dispatch({
    type: AI_MODEL_ASSIGNMENTS_ACTION_TYPE.GET_AI_MODEL_ASSIGNMENTS,
    payload: data,
  });
});

export const createAiModelAssignmentAction = catchAsyncActionError(body => async () => {
  const { data } = await aiModelAssignmentsApi.createAiModelAssignment(body);

  return data;
});

export const updateAiModelAssignmentAction = catchAsyncActionError(body => async () => {
  const { data } = await aiModelAssignmentsApi.updateAiModelAssignment(body);

  return data;
});

export const deleteAiModelAssignmentAction = catchAsyncActionError(id => async () => {
  await aiModelAssignmentsApi.deleteAiModelAssignment(id);
});
